<template>
    <div class="invite-user">
        <div style="position: relative">
            <img style="width: 100%;height: 100%" src="../../assets/img/agent_invitef.jpg" alt="">
            <div class="huo-guize" @click="guizeClickEvent">活动规则</div>
            <div class="back-view">
                <div class='v-t'>
                    <div class='t-title'>如何赚取奖励金<img style="width: 20px;height: 20px;vertical-align: middle;margin-left: 5px" src="../../assets/img/declare_img.png" alt=""></div>
                    <div class='t-b'>
                        <div class='clone'>
                            <div>
                                <div>1</div>
                            </div>
                            <div style="font-size: 14px;">
                                <div><span>点击屏幕右上角</span><img style="width: 25px;height: 20px;vertical-align: middle;" src="../../assets/img/point_r.png" alt=""><img style="width: 25px;height: 20px;vertical-align: middle;border: 1px solid blue" src="../../assets/img/indicate_img.png" alt=""><span style="padding-left: 10px;">根据弹出提示</span></div>
                                <div>选择<img style="width: 25px;height: 20px;vertical-align: middle;" src="../../assets/img/indicate_img2.png" alt="">分享给微信好友</div>
                            </div>
                        </div>
                        <div class='clone' style="margin-top: 10px;">
                            <div>
                                <div>2</div>
                            </div>
                            <div style="font-size: 14px;">
                                <div>也可以复制此 <span style="color: red">{{userinviteCode?userinviteCode:'您没有邀请码'}}</span> 邀请码</div>
                                <div>通过微信粘贴发送给好友</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import wx from 'weixin-js-sdk'
export default {
    data() {
        return {
            money_num: 0,
            userinviteCode: ''
        }
    },
    methods: {
        guizeClickEvent() {
            this.$router.push({
                path: '/userinfo/guize2'
            })
        },
        sharedFirend() {
            document.getElementById('here').scrollIntoView();
        }
    },
    mounted() {
        let _this = this;
        _this.$indicator.open('加载中...');
        _this.userinviteCode = _this.abp.UserInfos.userInfo.MyInvitationCode;
        _this.abp.api.BackDataForShare({
            type: 2,
            sigurl: location.href.split('#')[0]
        })
            .then(res => {
                _this.$indicator.close();
                if(res.status == 200) {
                    if(res.data.IsSuccess) {
                        let identificeData = JSON.parse(res.data.Data.replace("\"{","'{").replace("}\"","}'"));
                        // alert(identificeData.sigurl)
                        wx.config({
                            // debug: true,
                            appId: 'wx2ef8ae95cbbc8732',
                            timestamp: identificeData.timeStamp,
                            nonceStr: identificeData.nonceStr,
                            signature: identificeData.signature,
                            jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline']
                            // jsApiList: ['updateAppMessageShareData','updateTimelineShareData']
                        });
                    }else{
                        _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                    }
                }
            })
            .catch((error)=>{
                _this.$indicator.close();
                try {
                    switch(error.status) {
                        case 401:
                        _this.abp.api.reqSuccess(_this,'您没有权限！')
                    }
                } catch (txt) {
                    console.log(txt);
                }
            })
        wx.ready(function(res){
            // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            wx.onMenuShareAppMessage({
                title: '推荐你一个发财机会', // 分享时的标题
                desc: '我帮你找到了一款可以发大财的产品,快来关注一下',
                link: `${_this.abp.api.Host}#/home?userinviteCode=${_this.userinviteCode}`, // 分享时的链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://mtcarousel.obs.cn-north-4.myhuaweicloud.com/40cf25c5-1a7f-493b-9e93-e299fda70f83.jpg', // 分享时显示的图标
                // ../../assets/img/xc_back.jpg
                // http://portal.52kkl.com/carouselfigure/tfigure3.jpg
                //用户确认分享后执行的回调函数
                success: function (res) {
                    if(!_this.userinviteCode) {
                        _this.abp.api.reqSuccess(_this,'您没有邀请码，邀请失败')
                    }
                    console.log(res)
                    //给用户添加1次抽奖机会
                },
                //用户取消分享后执行的回调函数
                cancel: function () {
                    
                }
            });
            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.onMenuShareTimeline({
                title: '推荐你一个发财机会', // 分享时的标题
                desc: '我帮你找到了一款可以发大财的产品,快来关注一下',
                link: `${_this.abp.api.Host}#/home?userinviteCode=${_this.userinviteCode}`, // 分享时的链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://mtcarousel.obs.cn-north-4.myhuaweicloud.com/40cf25c5-1a7f-493b-9e93-e299fda70f83.jpg', // 分享时显示的图标
                //用户确认分享后执行的回调函数
                success: function (res) {
                    if(!_this.userinviteCode) {
                        _this.abp.api.reqSuccess(_this,'您没有邀请码，邀请失败')
                    }
                    console.log(res)
                    //给用户添加1次抽奖机会
                },
                //用户取消分享后执行的回调函数
                cancel: function () {
                    
                }
            });
        });
        // wx.error(function(res){
        //     console.log(res)
        //     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        // });
    }
}
</script>

<style scoped>
    .invite-user {
        position: absolute;
        top: 0;left: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
    }
    .invite-user .huo-guize {
        position: absolute;
        right: 0px;
        font-size: 14px;
        z-index: 10;
        top: 10px;
        background-color: #fff;
        color: #000;
        height: 30px;
        line-height: 30px;
        width: 80px;
        text-align: center;
        border-bottom-left-radius: 15px;
        border-top-left-radius: 15px;
    }
    .invite-user .back-view {
        position: absolute;
        left: 20px;
        right: 20px;
        bottom: 35px;
    }
    .invite-user .v-t>.t-title {
        height: 40px;
        font-size: 16px;
        text-align: center;
        line-height: 40px;
        color: #fa9981;
    }
    .invite-user .v-t>.t-b>.clone {
        display: flex;
    }
    .invite-user .v-t>.t-b>.clone>div:first-child {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .invite-user .v-t>.t-b>.clone>div:first-child>div {
        margin: auto;
        width: 20px;
        height: 20px;
        border-radius: 20px;
        border: 2px solid #ccc;
        color: #ccc;
        text-align: center;
        line-height: 20px;
    }
    .invite-user .v-t>.t-b>.clone>div:last-child {
        flex: 1;
    }
</style>
